import { OIV_TYPE } from './oiv-type.model';

export interface OivModel extends ParsedObject {
    content: OivModel[];
}

export interface HierarchyItem {
    eId: string;
    title?: string;
    attributeOrder?: string;
}

export interface ParsedObject {
    tag?: string;
    text?: string;
    oivAttr_eID?: string;
    'oivAttr_chapter-full'?: string;
    oivType?: OIV_TYPE;
    hierarchy?: HierarchyItem[];
    [key: string]: any;
}

export class OivTree {
    root: OivModel | null = null;
    constructor(rootValue: ParsedObject) {
        this.root = {
            ...rootValue,
            content: [],
        };
    }

    addChildToNode(parentNode: OivModel, childValue: ParsedObject): OivModel {
        const newChild = { ...childValue, content: [] };
        parentNode.content.push(newChild);
        return newChild;
    }

    addChildToRoot(value: ParsedObject): OivModel | null {
        if (!this.root) {
            return null;
        }
        return this.addChildToNode(this.root, value);
    }

    searchNodeByEid(eid: string, node = this.root): OivModel | null {
        if (!node) {
            return null;
        }
        if (node?.oivAttr_eID === eid) {
            return node;
        }
        for (const child of node.content) {
            const result = this.searchNodeByEid(eid, child);
            if (result) {
                return result;
            }
        }
        return null;
    }

    searchNodeByTag(name: string | RegExp, fullName = false, node = this.root, result: OivModel[] = []): OivModel[] {
        if (!node) {
            return [];
        }
        const isString = typeof name === 'string';
        const nameRegex = isString ? new RegExp(name as string) : (name as RegExp);

        if (fullName && isString ? node.tag === name : nameRegex.test(node.tag || '')) {
            result.push(node);
        }
        for (const child of node.content) {
            this.searchNodeByTag(name, fullName, child, result);
        }
        return result;
    }

    searchParentOfNode(childEid: string, node = this.root): OivModel | null {
        if (!node) {
            return null;
        }
        for (const child of node.content) {
            if (child.oivAttr_eID === childEid) {
                return node;
            }
            const result = this.searchParentOfNode(childEid, child);
            if (result) {
                return result;
            }
        }
        return null;
    }

    searchNodeByType(type: OIV_TYPE, node = this.root, result: OivModel[] = []): OivModel[] {
        if (!node) {
            return [];
        }
        if (node.oivType === type) {
            result.push(node);
        }
        for (const child of node.content) {
            this.searchNodeByType(type, child, result);
        }
        return result;
    }

    getPrecedingSiblingOfNode(childEid: string, node = this.root): OivModel | null {
        if (!node || !childEid) {
            return null;
        }
        for (let i = 0; i < node.content.length; i++) {
            if (node.content[i].oivAttr_eID === childEid && i > 0) {
                return node.content[i - 1];
            }
            const result = this.getPrecedingSiblingOfNode(childEid, node.content[i]);
            if (result) {
                return result;
            }
        }
        return null;
    }
}
